import { compact, filter, find, go, join, map, pluck, head, sortBy, reject, sel, some, sort } from 'fxjs/es';
import { $data, $find, $findAll } from 'fxdom/es';
import { BpOptionSelectedOptionGroupS } from '../../SelectedOptionGroup/S/Function/module/BpOptionSelectedOptionGroupS.js';
import { getAllBpOptions, getDefaultBpOptionIdFromBpOption } from './get.js';
import { BpOptionS } from '../../S/Function/module/BpOptionS.js';
import { BpOptionKeyRingConstantS } from '@modules/BpOption/KeyRing/S/Constant/module/BpOptionKeyRingConstantS.js';
import { getProductColorInMaker } from '@modules/Maker/F/getSth.js';
import { getCurrentFcanvas } from '../../../Maker/F/Fcanvas/cv_object.js';
import { NewMakerEndServiceF } from '../../../NewMaker/EndService/F/Function/module/NewMakerEndServiceF.js';

export const getSelectedOptionGroupBpOptions = (selected_option_group) => {
  return go(
    getAllBpOptions(),
    filter((bp_option) => selected_option_group.bp_option_ids.includes(bp_option.id)),
  );
};

export const getBpOptionById = (bp_option_id) => {
  return go(
    getAllBpOptions(),
    find((bp_option) => bp_option.id == bp_option_id),
  );
};

// export const setSelectedOptionGroupBpOptions = (selected_option_group) => {
//   /* 시간 될때 지워보자 _ 없어도 될듯 */
//   selected_option_group._ = selected_option_group._ || {};
//   // selected_option_group._.bp_options = getSelectedOptionGroupBpOptions(selected_option_group);
//   return selected_option_group;
// };

export const setSelectedOptionGroupWithDefaultBpOptionIds = (product) => {
  product._.selected_option_group = product._.selected_option_group || {};
  product._.selected_option_group._ = product._.selected_option_group._ || {};
  const default_bp_option_ids = BpOptionS.getDefaultBpOptionIds(product);
  if (default_bp_option_ids?.length) {
    product._.selected_option_group.bp_option_ids = default_bp_option_ids;
    // setSelectedOptionGroupBpOptions(product._.selected_option_group);
  } else {
    // console.log('bp_option 이 없는 경우');
    /* bp_options 가 없는 상품이라면 */
    product._.selected_option_group = {};
  }
};

function getPriceJsonBpDiscountRangeOption() {
  const bp_discount_range_option =
    box().maker.product_color._.base_product._?.bp_discount_set?._?.bp_discount_ranges?.[0]?._
      ?.bp_discount_range_options?.[0];
  return bp_discount_range_option?.price_json && bp_discount_range_option;
}

function getMinimumSize(bp_discount_range_option) {
  if (bp_discount_range_option?.price_type === 'AREA') {
    const price = go(
      bp_discount_range_option.price_json,
      sortBy(({ area }) => area),
      head,
    );
    const size = parseInt(Math.sqrt(price.area));
    return {
      width: size,
      height: size,
    };
  }
}

function makeSize() {
  if (G.mp.maker.flexiMaker) {
    const JOGAK_STICKER_DEFAULT_SIZE = { width: 30, height: 30 };
    return G.mp.maker.flexiMaker.hasImage ? G.mp.maker.flexiMaker.imageSize : JOGAK_STICKER_DEFAULT_SIZE;
  }
  const bp_discount_range_option = getPriceJsonBpDiscountRangeOption();

  if (NewMakerEndServiceF.makerStatus.isKeyringEditor() && bp_discount_range_option) {
    const fcanvas = getCurrentFcanvas();
    const cv_obj = go(
      fcanvas._objects,
      find((cv_obj) => cv_obj.cid == 'c2323'),
    );
    const default_size = getMinimumSize(bp_discount_range_option);
    return cv_obj?._data?.fitted_size || default_size;
  }
}
export const makeSelectedOptionGroup = (bp_option_groups_el) => {
  const bp_option_ids = go(
    bp_option_groups_el,
    $findAll('.bp_option_group'),
    map($find('select')),
    map((select_el) => parseInt(select_el.value)),
    sort,
  );

  const title_option_els = go(
    bp_option_groups_el,
    $findAll('.bp_option_group[data-is_name="true"] select'),
    compact,
    map((select_el) => $find(`option[value="${select_el.value}"]`)(select_el)),
    reject((el) => el.dataset?.name === '추가 안함'),
    compact,
  );

  const selected_bp_options = go(
    bp_option_groups_el,
    $findAll('.bp_option_group[data-is_name="true"] select'),
    compact,
    map((select_el) => {
      const bp_option_group = $data(select_el);
      const option = $data($find(`option[value="${select_el.value}"]`)(select_el));
      return {
        ...option,
        _: {
          bp_option_group,
        },
      };
    }),
  );
  const option_names = BpOptionSelectedOptionGroupS.makeOptionNames(selected_bp_options);

  if (bp_option_ids.includes(BpOptionKeyRingConstantS.NOT_FREE_BP_OPTION_ID)) {
    /* 규격형 키링만 따로 처리 */
    const product = getProductColorInMaker();
    const _data = product.product_faces2.value[0].designs?.[1]?._data;
    const fitted_size = _data?.fitted_size;
    const real_height_mm = _data?.real_height_cm * 10;
    if (fitted_size && real_height_mm) {
      const title = `${fitted_size.width} x ${parseInt(real_height_mm)} mm`;
      const title_en = `${(fitted_size.width / 2.54).toFixed(2)} x ${(real_height_mm / 2.54).toFixed(2)} inch`;
      const title_jp = title;
      const option_names = [
        {
          no: 6,
          is_name: true,
          option_name: title,
          option_name_en: title_en,
          option_name_jp: title_jp,
          option_group_name: '사이즈',
          option_group_name_en: 'Size',
          option_group_name_jp: 'サイズ',
        },
      ];
      return {
        bp_option_ids,
        title,
        title_en,
        title_jp,
        option_names,
        _: {
          bp_options: selected_bp_options,
        },
      };
    }
  }
  const size = makeSize();
  const nfc_info = box().maker.product_color._.selected_option_group._?.nfc_info;

  if (G.collabo_type !== '' && (G.mp.maker.flexiMaker || G.mp.maker.nfcProduct)) {
    const title = G.mp.maker.flexiMaker
      ? go(
          option_names,
          reject(({ option_group_name }) => option_group_name === '테두리'),
          pluck('option_name'),
          join(' - '),
        )
      : G.mp.maker.nfcProduct
        ? go(
            option_names,
            find(({ option_group_name }) => option_group_name === '사이즈'),
            sel('option_name'),
          )
        : '';

    return {
      bp_option_ids,
      title,
      title_en: title,
      title_jp: title,
      option_names,
      size,
      _: {
        bp_options: selected_bp_options,
        nfc_info,
      },
    };
  }

  return {
    bp_option_ids,
    title:
      go(
        title_option_els,
        map((el) => el?.dataset?.name),
        join('-'),
      ) || '',
    title_en:
      go(
        title_option_els,
        map((el) => el?.dataset?.name_en),
        join('-'),
      ) || '',
    title_jp:
      go(
        title_option_els,
        map((el) => el?.dataset?.name_jp),
        join('-'),
      ) || '',
    option_names,
    size,
    _: {
      bp_options: selected_bp_options,
      nfc_info,
    },
  };
};

export const getSelectedBpOptionIncludingHiddenBpOption = (selected_option_group) => {
  if (!selected_option_group?.bp_option_ids?.length) return;
  return go(
    getAllBpOptions(),
    filter((bp_option) => !bp_option.is_public),
    filter((bp_option) => selected_option_group.bp_option_ids.includes(bp_option.id)),
  );
};

export const setSelectedBpOptionGroupsHiddenBpOptionIdsWithDefault = (
  selected_option_group,
  hidden_bp_options,
) => {
  selected_option_group.bp_option_ids = go(
    selected_option_group.bp_option_ids,
    reject((bp_option_id) =>
      go(
        hidden_bp_options,
        some((hidden_bp_option) => hidden_bp_option.id == bp_option_id),
      ),
    ),
  ).concat(go(hidden_bp_options, map(getDefaultBpOptionIdFromBpOption)));
};
